import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { ChatMessageSendingJobDetailPageScheduledTimeFragmentDoc } from './ChatMessageSendingJobDetailPageScheduledTime/ChatMessageSendingJobDetailPageScheduledTime.generated';
import { ChatMessageSendingJobDetailPageDeleteButtonFragmentDoc } from './ChatMessageSendingJobDetailPageDeleteButton/ChatMessageSendingJobDetailPageDeleteButton.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatMessageSendingJobDetailPageQueryVariables = Types.Exact<{
  guid: Types.Scalars['ID']['input'];
}>;


export type ChatMessageSendingJobDetailPageQuery = { __typename?: 'Query', chatMessageSendingJob?: { __typename?: 'ChatMessageSendingJob', guid: string, target: string, deliveredCount?: number | null, status: Types.ChatMessageSendingJobStatus, sentAt?: TimeString | null, scheduledAt?: TimeString | null, messages: Array<{ __typename: 'ChatMessageSendingJobMessageImage', guid: string, imageUri: string, linkUri: string, altText: string } | { __typename: 'ChatMessageSendingJobMessageQuestion', guid: string, body: string, selections: Array<string> } | { __typename: 'ChatMessageSendingJobMessageText', guid: string, text: string }>, statistics?: { __typename?: 'ChatMessageSendingJobStatistics', overview: { __typename?: 'ChatMessageSendingJobStatisticsOverview', uniqueImpression?: number | null, uniqueClick?: number | null }, message: Array<{ __typename?: 'ChatMessageSendingJobStatisticsMessage', seq?: number | null, uniqueImpression?: number | null }>, click: Array<{ __typename?: 'ChatMessageSendingJobStatisticsClick', seq?: number | null, url?: string | null, uniqueClick?: number | null }> } | null } | null };


export const ChatMessageSendingJobDetailPageDocument = gql`
    query ChatMessageSendingJobDetailPage($guid: ID!) {
  chatMessageSendingJob(guid: $guid) {
    guid
    target
    deliveredCount
    status
    messages {
      __typename
      ... on ChatMessageSendingJobMessageText {
        guid
        text
      }
      ... on ChatMessageSendingJobMessageImage {
        guid
        imageUri
        linkUri
        altText
      }
      ... on ChatMessageSendingJobMessageQuestion {
        guid
        body
        selections
      }
    }
    sentAt
    scheduledAt
    statistics {
      overview {
        uniqueImpression
        uniqueClick
      }
      message {
        seq
        uniqueImpression
      }
      click {
        seq
        url
        uniqueClick
      }
    }
  }
  ...ChatMessageSendingJobDetailPageScheduledTime
  ...ChatMessageSendingJobDetailPageDeleteButton
}
    ${ChatMessageSendingJobDetailPageScheduledTimeFragmentDoc}
${ChatMessageSendingJobDetailPageDeleteButtonFragmentDoc}`;

/**
 * __useChatMessageSendingJobDetailPageQuery__
 *
 * To run a query within a Vue component, call `useChatMessageSendingJobDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageSendingJobDetailPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatMessageSendingJobDetailPageQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useChatMessageSendingJobDetailPageQuery(variables: ChatMessageSendingJobDetailPageQueryVariables | VueCompositionApi.Ref<ChatMessageSendingJobDetailPageQueryVariables> | ReactiveFunction<ChatMessageSendingJobDetailPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables>(ChatMessageSendingJobDetailPageDocument, variables, options);
}
export function useChatMessageSendingJobDetailPageLazyQuery(variables?: ChatMessageSendingJobDetailPageQueryVariables | VueCompositionApi.Ref<ChatMessageSendingJobDetailPageQueryVariables> | ReactiveFunction<ChatMessageSendingJobDetailPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables>(ChatMessageSendingJobDetailPageDocument, variables, options);
}
export type ChatMessageSendingJobDetailPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatMessageSendingJobDetailPageQuery, ChatMessageSendingJobDetailPageQueryVariables>;